
import React from 'react'
//Styles
import './Takeout.css'
// Assets
import pituba_distribution_center_location_map from '../../images/pituba_distribution_center_location_map.png'

const Takeout = () => {
  return (
    <div className='takeout__container'>
      <p className='takeout__paragraph'>
        O centro de distribuição mais próximo a você se situa no bairro da <b>
          Pituba, Rua Minas Gerais, 486
        </b>
      </p>
      <img
        className='takeout__map'
        src={pituba_distribution_center_location_map}
        alt='Mapa mostrando a localização do big delivery'
      />
      <p className='takeout__paragraph'>
        Após o pagamento seu pedido
        entrará em processo de produção
        e você será notificado assim que
        estiver disponível para retirada!
      </p>

    </div>
  )
}
export default Takeout